import React, {useEffect, useState} from 'react';
import {useToggleCartIfurn} from "../model/useToggleCartIfurn";
import styled from "styled-components";
import Button from "../../../../../shared/ui/button/Button";
import {GLOBAL_STYLE_CONFIG} from "../../../../../app/styles/GlobalStyles";
import IconBasket from "../../../../../shared/ui/icons/icon-basket.ui";
import {GoodsType} from "../../../../../entities/goods/model/types/goods-type";
import {useToggleCart} from "../../../../../features/goods/toggle-goods-to-cart/model/useToggleCart";

const StyledButton = styled(Button)`

    svg path {
        stroke: var(${GLOBAL_STYLE_CONFIG.variable('button', 'text-color')}, white);
    }

    &.is-in-cart {
        background-color: transparent;
        border: 1px solid ${({theme}) => theme.colors.primary};

        svg path {
            stroke: var(${GLOBAL_STYLE_CONFIG.variable('button', 'hover-text-color')},
            ${({theme}) => theme.colors.primary});
        }
    }

`

interface IProps {
    goods: GoodsType
}

/**
 * Компонента, отвечающая за жизненный цикл товара в корзине.
 * - Инкапсулирует логику добавления/удаления товара через useToggleCart
 * - Управляет состоянием кнопки, проверяя наличие товара в корзине (isInCart)
 *
 * @param {GoodsType} goods - объект товара
 * @returns {JSX.Element}
 */

const ToggleCartButtonIfurn: React.FC<IProps> = ({goods}) => {
    const {inCart, toggleCart} = useToggleCartIfurn(goods);
    const onToggleHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        toggleCart();
    }
    const classname = `${GLOBAL_STYLE_CONFIG.splitByPrefix('card-add-to-cart')} ${inCart ? 'is-in-cart' : ''}`;
    return (
        <StyledButton onClick={onToggleHandler} className={classname}>
            <IconBasket/>
        </StyledButton>
    );
};

export default ToggleCartButtonIfurn;